import axiosInstance from "utils/InstanceAxios/InstanceAxios";
import serviceLayer from "utils/InstanceAxios/serviceLayer";
import axiosInstanceV2 from "utils/InstanceAxios/InstanceAxiosV2";
import { Types } from "../reducers/collections";
import { Types as FileSystemTypes } from "../reducers/fileSystem";
import * as serverRoutes from "utils/consts/serverRoutes.js";
import { toast } from "react-toastify";

//Synchronous
export const clearCollectionRegister = () => {
  return (dispatch) => {
    dispatch({
      type: Types.CLEAR_COLLECTIONS_REGISTER,
    });
  };
};

//Asynchronous
export const getPipelineMetadata = (user_id, file_path, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .get(serverRoutes.Collection(`/pipeline-metadata/${user_id}/${file_path}`))
      .then((response) => {
        dispatch({
          type: Types.GET_PIPELINE_METADATA,
          payload: { content: response.data, connect: true },
        });
        callback();
      })
      .catch((err) => {
        dispatch({
          type: Types.GET_PIPELINE_METADATA,
          payload: null,
        });
        callback();
      });
  };
};

export const createCollection = (collection, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection(), collection)
      .then((response) => {
        dispatch({
          type: Types.CREATE_COLLECTION,
        });
        callback(true);
      })
      .catch((err) => {
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        callback(false, message);
      });
  };
};

export const updateCollection = (collection, callback) => {
  return (dispatch) => {
    axiosInstance
      .put(serverRoutes.Collection(`/${collection.id}`), { collection })
      .then((response) => {
        dispatch({
          type: Types.UPDATE_COLLECTION,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        callback(false, message);
      });
  };
};

export const updateCollectionMER = (collectionMER, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.CollectionMER(`/${collectionMER.id_colecao}`), { collectionMER })
      .then((response) => {
        dispatch({
          type: Types.UPDATE_COLLECTION_MODEL,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        callback(false, message);
      });
  };
};

export const getCollectionMER = (idCollection, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .get(serverRoutes.CollectionMER(`/${idCollection}`))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION_MODEL,
          payload: response.data,
        });
        callback(true, response.data);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        callback?.(false, message);
      });
  };
};


export const saveRelations = (payload, callback) => {
  return (dispatch) => {

    axiosInstanceV2
      .put("/entity-relationship-model/save-relations", payload)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_COLLECTION_MODEL,
          payload: response.data,
        });

        callback?.(true, response.data);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.message;
        callback?.(false, message);
      });
  };
};

export const getMERCollectionConfiguration = (collectionId, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .get(serverRoutes.CollectionMER(`/configuration/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION_MODEL,
          payload: response.data,
        });
        callback(true, response.data);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        callback?.(false, message);
      });
  };
};


export const updateEntityRelationshipModelMetadata = (collectionId, metadata, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .put(serverRoutes.CollectionMER(`/configuration/${collectionId}`), metadata)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_COLLECTION_MODEL,
          payload: response.data,
        });
        callback?.(true, response.data);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        callback?.(false, message);
      });
  };
};



export const createIngestorDirectory = (collectionId, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .put(serverRoutes.CreateCollectionIngestorDirectory(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.CREATE_DIRECTORY_INGESTOR_SUCCESS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        const message = err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.CREATE_DIRECTORY_INGESTOR_ERROR,
          payload: message,
        });
        callback(false, message);
        toast.error(message, { autoClose: 10000 });
      });
  };
};

export const getCollection = (collectionId) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    dispatch({
      type: Types.GET_COLLECTION,
      payload: null,
    });
    axiosInstance
      .get(serverRoutes.Collection(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION,
          payload: null,
        });
      });
  };
};

export const getCollections = (page, limit, query, sort = "", filters = {}) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_COLLECTIONS,
      payload: { collections: [], maxPages: 1 },
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(
        serverRoutes.Collection("", { page, limit, query, sort, ...filters })
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: { collections: [], maxPages: 1 },
        });
      });
  };
};

export const getCatalog = (page, limit, query, sort = "", filters = {}) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.Catalog("", { page, limit, query, sort, ...filters }))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: { collections: [], maxPages: 1 },
        });
      });
  };
};

export const deleteCollection = (collectionId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    const { collections } = getState();

    axiosInstance
      .delete(serverRoutes.Collection(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_COLLECTION,
          payload: response.data,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.DELETE_COLLECTION,
          payload: collections.collections,
        });
        callback(false);

        toast.error(message, { autoClose: 10000 });
      });
  };
};

export const deleteCollectionCarga = (collectionId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    const { collections } = getState();

    axiosInstance
      .delete(serverRoutes.DeleteCollectionCarga(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_COLLECTION_CARGA,
          payload: response.data,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.DELETE_COLLECTION_CARGA,
          payload: collections.collections,
        });

        toast.error(message, { autoClose: 10000 });
      });
  };
};

export const inactivateCollection = (collectionId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    const { collections } = getState();

    axiosInstance
      .put(serverRoutes.InactivateCollection(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.INACTIVATE_COLLECTION,
          payload: response.data,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.INACTIVATE_COLLECTION,
          payload: collections.collections,
        });

        toast.error(message, { autoClose: 10000 });
      });
  };
};

export const reactivateCollection = (collectionId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    const { collections } = getState();

    axiosInstance
      .put(serverRoutes.ReactivateCollection(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.REACTIVATE_COLLECTION,
          payload: response.data,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.REACTIVATE_COLLECTION,
          payload: collections.collections,
        });

        toast.error(message, { autoClose: 10000 });
      });
  };
};

export const verifyConnection = (
  connectionURL,
  driverId,
  username,
  password,
  callback
) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection("/verifyConnection"), {
        connectionURL,
        driverId,
        username,
        password,
      })
      .then((response) => {
        const result = {
          message: (response.data && response.data.message) || response.data,
          connect: true,
        };
        dispatch({
          type: Types.VERIFY_CONNECTION,
          payload: result,
        });
        callback(result);
      })
      .catch((err) => {
        console.log(err);
        const result = {
          message:
            err?.response?.data.error || err?.response?.data || err.message,
          connect: false,
        };
        dispatch({
          type: Types.VERIFY_CONNECTION,
          payload: result,
        });
        callback(result);
      });
  };
};

export const verifyCollectionConnection = (
  collectionId,
  connectionId,
  callback
) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection("/verifyCollectionConnection"), {
        collectionId,
        connectionId,
      })
      .then((response) => {
        const result = {
          message: (response.data && response.data.message) || response.data,
          connect: true,
        };
        dispatch({
          type: Types.VERIFY_CONNECTION,
          payload: result,
        });
        callback(result);
      })
      .catch((err) => {
        console.log(err);
        const result = {
          message:
            err?.response?.data.error || err?.response?.data || err.message,
          connect: false,
        };
        dispatch({
          type: Types.VERIFY_CONNECTION,
          payload: result,
        });
        callback(result);
      });
  };
};

export const verifyCollectionAssociation = (nomecolecao) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.verifyCollectionAssociation, { nomecolecao })
      .then((response) => {
        dispatch({
          type: Types.VERIFY_COLLECTION_ASSOCIATION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
};

export const executeQuery = (
  connectionURL,
  driverId,
  username,
  password,
  query,
  callback
) => {
  return (dispatch) => {
    dispatch({
      type: Types.EXECUTE_QUERY,
      payload: null,
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .post(serverRoutes.Collection("/executeQuery"), {
        connectionURL,
        driverId,
        username,
        password,
        query,
      })
      .then((response) => {
        const result = {
          content: response.data,
          connect: true,
        };
        dispatch({
          type: Types.EXECUTE_QUERY,
          payload: result,
        });
        callback(result);
      })
      .catch((err) => {
        const result = {
          content: err?.response?.data || err?.message || "",
          connect: false,
        };
        dispatch({
          type: Types.EXECUTE_QUERY,
          payload: result,
        });
        callback(result);
      });
  };
};

export const executeCollectionQuery = (
  collectionId,
  connectionId,
  query,
  currentUserName,
  callback
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .post(serverRoutes.Collection("/executeCollectionQuery"), {
        collectionId,
        connectionId,
        query,
        currentUserName
      })
      .then((response) => {
        const result = {
          content: response.data,
          connect: true,
        };
        dispatch({
          type: Types.EXECUTE_QUERY,
          payload: result,
        });
        callback(result);
      })
      .catch((err) => {
        const result = {
          content: err?.response?.data || err?.message || "",
          connect: false,
        };
        dispatch({
          type: Types.EXECUTE_QUERY,
          payload: result,
        });
        callback(result);
      });
  };
};

export const uploadMetadata = (file, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection("/uploadMetadata"), file, {
        onUploadProgress: (e) => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          callback({ progress });
        },
      })
      .then((response) => {
        dispatch({
          type: Types.UPLOAD_METADATA,
          payload: { content: response.data.metadata, connect: true },
        });

        callback({
          uploaded: true,
          id: response.data.uploadedMetadata._id,
          // url: response.data.url
          path: response.data.path,
        });
      })
      .catch((err) => {
        dispatch({
          type: Types.UPLOAD_METADATA,
          payload: null,
        });
        callback({
          error: true,
          id: err.response?.data?._id,
        });
      });
  };
};

export const compareAndUploadMetadata = (file, collectionId, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection(`/compareMetadata/${collectionId}`), file, {
        onUploadProgress: (e) => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          callback({ progress });
        },
      })
      .then((response) => {
        dispatch({
          type: Types.UPLOAD_METADATA,
          payload: { content: response.data.metadata, connect: true },
        });

        callback({
          uploaded: true,
          id: response.data.uploadedMetadata._id,
          // url: response.data.url
          path: response.data.path,
        });
        toast.success("Metadados validados com sucesso.", { autoClose: 5000 });
      })
      .catch((err) => {
        const message =
          err.response?.data?.error || err.response?.data || err.message;
        dispatch({
          type: Types.UPLOAD_METADATA,
          payload: null,
        });
        callback({
          error: true,
          id: err.response?.data?._id,
          details: err.response?.data?.details,
        });
        toast.error(message, { autoClose: 10000 });

      });
  };
};

export const deleteMetadata = (fileId, callback) => {
  return (dispatch) => {
    axiosInstance
      .delete(serverRoutes.Collection(`/uploadMetadata/${fileId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_METADATA,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        callback();
      });
  };
};

export const uploadIngestFile = (collectionId, itemId, file, callback) => {
  return (dispatch, getState) => {
    axiosInstanceV2
      .post(serverRoutes.Collection(`/uploadIngestFile/${collectionId}/${itemId}`), file, {
        onUploadProgress: (e) => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          callback({ progress });
        },
      })
      .then((response) => {
        const { fileSystem } = getState();
        // Upload file system state
        dispatch({
          type: FileSystemTypes.UPLOAD_FILE,
          payload: [...(fileSystem.directory || []), `${itemId}/${response.data}`],
        });

        callback({
          uploaded: true,
          id: response.data,
        });
      })
      .catch((err) => {
        // Upload file system state
        dispatch({
          type: FileSystemTypes.UPLOAD_FILE,
          payload: null,
        });
        callback({
          error: true,
          id: err.response?.data?._id,
          details: err.response?.data?.details,
        });
      });
  };
};

export const ingestFile = (file, collectionId, token, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection(`/ingestFile`), {
        file,
        collectionId,
        token,
      })
      .then((response) => {
        callback(true);
      })
      .catch((err) => {
        let message =
          err.response?.data?.error || err.response?.data || err.message;
        if (message !== "Ingestão expirada.") {
          message = "Ocorreu um erro durante processamento do arquivo.";
        }
        console.log(err);
        callback(false, message);
      });
  };
};

export const getCollectionByIngestToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.Collection(`/ingestFile/${token}`))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION,
          payload: null,
        });
      });
  };
};

export const saveCollectionCreation = (collection, callback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection("/save"), collection)
      .then((response) => {
        dispatch({
          type: Types.SAVE_COLLECTION_CREATION,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        callback(false);
        console.log(err);
      });
  };
};

export const getCollectionUsage = (
  page,
  limit,
  query,
  sort = "",
  filter = "",
  period = null
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(
        serverRoutes.CollectionsUsage("", {
          page,
          limit,
          query,
          sort,
          filter,
          period,
        })
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION_USAGE,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION_USAGE,
          payload: [],
        });
      });
  };
};

export const uploadMetadataFile = (file, callback, setMetadataCallback) => {
  return (dispatch) => {
    axiosInstance
      .post(serverRoutes.Collection("/uploadMetadataFile"), file, {
        onUploadProgress: (e) => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          callback({ progress });
        },
      })
      .then((response) => {
        callback({ uploaded: true });
        setMetadataCallback(response.data.metadata);
      })
      .catch((err) => {
        console.log(err);
        callback({
          error: true,
          id: err.response?.data?._id,
        });
      });
  };
};

export const getCollectionPreview = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_PREVIEW_COLLECTION,
      payload: null,
    });
    dispatch({
      type: Types.SET_LOADING_PREVIEW,
    });
    serviceLayer.get('/buscar', {
      headers: {
        Authorization: token,
        offset: 0,
        limit: 10,
      },
    })
      .then((response) => {
        if (response.data?.Mensagem) {
          dispatch({
            type: Types.GET_PREVIEW_COLLECTION,
            payload: null,
          });
        } else {
          dispatch({
            type: Types.GET_PREVIEW_COLLECTION,
            payload: response.data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_PREVIEW_COLLECTION,
          payload: null,
        });
      });
  };
};

export const addNewCollectionExecution = (collectionId, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.AddNewCollectionExecution(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.ADD_NEW_COLLECTION_EXECUTION,
        });
        callback(true, response.data?.message);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.ADD_NEW_COLLECTION_EXECUTION,
        });

        const message =
          err.response?.data?.error ||
          err.response?.data?.message ||
          'Não foi possível iniciar a execução.';

        callback(false, message);
      });
  };
}

export const addNewCollectionTruncate = (collectionId, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.AddNewCollectionTruncate(`/${collectionId}`))
      .then((response) => {
        dispatch({
          type: Types.ADD_NEW_COLLECTION_TRUNCATE,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.ADD_NEW_COLLECTION_TRUNCATE,
        });
        callback(false);
      });
  };
}

export const getAllSystemCollections = (systemslug) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_ALL_SYSTEM_COLLECTIONS,
      payload: [],
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.getAllSystemCollections(`/${systemslug}`))
      .then((response) => {
        dispatch({
          type: Types.GET_ALL_SYSTEM_COLLECTIONS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_ALL_SYSTEM_COLLECTIONS,
          payload: [],
        });
      });
  };
};

export const getAllDomainCollections = (domainname) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_ALL_DOMAIN_COLLECTIONS,
      payload: [],
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.getAllDomainCollections(`/${domainname}`))
      .then((response) => {
        dispatch({
          type: Types.GET_ALL_DOMAIN_COLLECTIONS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_ALL_DOMAIN_COLLECTIONS,
          payload: [],
        });
      });
  };
};

export const confirmToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_TOKEN,
      payload: null,
    });
    dispatch({
      type: Types.SET_LOADING_TOKEN,
    });
    serviceLayer.get('/info', {
      headers: {
        Authorization: token,
      },
    })
      .then((response) => {
        dispatch({
          type: Types.GET_TOKEN,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_TOKEN,
          payload: null,
        });
      });
  };
};

export const getCollectionByToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.Collection(`/token/${token}`))
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION,
          payload: null,
        });
      });
  };
};

export const getDerivativeCollections = (page, limit, query, sort = "", filters = {}) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_COLLECTIONS,
      payload: { collections: [], maxPages: 1 },
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(
        serverRoutes.DerivativeCollection("", { page, limit, query, sort, ...filters })
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTIONS,
          payload: { collections: [], maxPages: 1 },
        });
      });
  };
};

export const getCollectionUsageDerivative = (
  page,
  limit,
  query,
  sort = "",
  filter = "",
  period = null
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(
        serverRoutes.DerivativeCollectionsUsage("", {
          page,
          limit,
          query,
          sort,
          filter,
          period,
        })
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION_USAGE,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION_USAGE,
          payload: [],
        });
      });
  };
};

export const clearToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_TOKEN,
      payload: null,
    });
  };
};

export const refreshCollectionToken = (associationId, callback) => {
  return (dispatch) => {
    axiosInstance.put(serverRoutes.refreshCollectionToken(`/${associationId}`))
      .then((response) => {
        if (typeof callback === 'function') {
          callback(true);
        }
        dispatch({
          type: Types.UPDATE_COLLECTION_TOKEN,
          payload: response.data
        });
        toast.success("Token de coleção atualizado com sucesso!", { autoClose: 10000 });
      })
      .catch((err) => {
        if (typeof callback === 'function') {
          callback(false);
        }
        console.log(err)
        toast.error("Erro ao atualizar token de coleção.", { autoClose: 10000 });
      })
  }
}

export const confirmTokenChange = (token, fields, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING_TOKEN,
    });
    serviceLayer.get('/info', {
      headers: {
        Authorization: token,
      },
    })
      .then((response) => {
        if (fields.every(field => {
          return response.data?.metadados[0]?.map(metadado => metadado.campo)?.includes(field)
        })) {
          axiosInstance
            .get(serverRoutes.Collection(`/token/${token}`))
            .then((collectionResponse) => {
              if (collectionResponse.data._id) {
                callback(collectionResponse.data._id);
                dispatch({
                  type: Types.GET_TOKEN,
                  payload: response.data,
                });
              } else {
                callback(false);
              }
            })
            .catch((err) => {
              callback(false);
              console.log(err);
              dispatch({
                type: Types.GET_TOKEN,
                payload: null,
              });
            });
        } else {
          callback(false)
        }
      })
      .catch((err) => {
        callback(false)
        console.log(err);
      });
  };
};

export const getIsCollectionTokenDerivated = (token) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstance
      .get(serverRoutes.Collection(`/is-token-derivated/${token}`))
      .then((response) => {
        dispatch({
          type: Types.IS_COLLECTION_TOKEN_DERIVATED,
          payload: true,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.IS_COLLECTION_TOKEN_DERIVATED,
          payload: false,
        });
      });
  };
};
